var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEjectTip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 47,
    viewBox: "0 0 46 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0088 3.17577L27 3.21009L26.9912 4.45946L26.5444 4.45754L26.126 13.8263L25.6866 13.8245L25.2877 19.4442L24.8567 19.4424L23.5222 43.1759L21.924 43.1711L20.9226 19.4255L20.4929 19.4237L20.1721 13.8008L19.733 13.7989L19.4462 4.42705L19 4.42514L19.0088 3.17577Z",
    fill: "#003E6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 35.1758L12 12.1758",
    stroke: "#ED3431",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 23.6758,
    r: 16,
    stroke: "#ED3431",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEjectTip);
export default __webpack_public_path__ + "static/media/Eject_Tip.f9358991143fa2fa9c7b439541afb8a1.svg";
export { ForwardRef as ReactComponent };